import { Zap, TrendingUp, ShieldCheck, Leaf, FileBarChart, Workflow } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    name: "Save Time",
    description: "Automate compliance tasks to reclaim over 100 hours annually.",
    icon: Zap,
    gradient: "from-[#00DC82] to-[#00A3FF]"
  },
  {
    name: "Enhance Profitability",
    description: "Transform compliance from a cost centre into a strategic advantage.",
    icon: TrendingUp,
    gradient: "from-[#00DC82] to-[#00A3FF]"
  },
  {
    name: "Ensure Compliance",
    description: "Stay ahead of evolving sustainability standards effortlessly.",
    icon: ShieldCheck,
    gradient: "from-[#00DC82] to-[#00A3FF]"
  },
  {
    name: "Reduce Waste",
    description: "Utilise data-driven insights to optimise material usage and minimise waste.",
    icon: Leaf,
    gradient: "from-[#00DC82] to-[#00A3FF]"
  },
  {
    name: "Simplify Reporting",
    description: "Generate comprehensive, audit-ready compliance reports in minutes.",
    icon: FileBarChart,
    gradient: "from-[#00DC82] to-[#00A3FF]"
  },
  {
    name: "Data Workflows",
    description: "Streamlining design to manufacturing processes with data-driven workflows.",
    icon: Workflow,
    gradient: "from-[#00DC82] to-[#00A3FF]"
  },
];

export function FeaturesSectionWithHoverEffects() {
  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <motion.h2
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold relative mb-2 sm:mb-4 pb-1 leading-tight"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <div className="absolute -inset-1 bg-gradient-to-r from-[#00DC82]/20 to-transparent blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <span className="text-foreground">Empower your</span> <span className="text-[#00DC82]">Manufacturing with Sentiri</span>
          </motion.h2>
          {/* <p className="max-w-4xl mx-auto text-sm sm:text-base md:text-lg text-muted-foreground leading-relaxed mb-8 sm:mb-16 md:mb-20">
            Sentiri automates compliance and material tracking for construction product manufacturers.
          </p> */}
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {features.map((feature, index) => (
            <motion.div 
              key={feature.name} 
              className="group relative bg-card rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1 border-[1.5px] border-[#00DC82]/10 hover:border-[#00DC82] hover:shadow-[#00DC82]/30 hover:shadow-2xl"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className={`absolute inset-0 opacity-[0.03] bg-gradient-to-br ${feature.gradient}`} />
              
              <div className="relative p-4 sm:p-5 md:p-6">
                <div className="w-10 h-10 md:w-12 md:h-12 mb-3 md:mb-4 text-[#00DC82] group-hover:scale-110 transition-transform duration-500">
                  <feature.icon className="w-full h-full" />
                </div>
                
                <h3 className="text-xl sm:text-2xl font-semibold text-card-foreground mb-2 md:mb-3 group-hover:text-[#00DC82] transition-colors duration-300">
                  {feature.name}
                </h3>
                <p className="text-base sm:text-lg text-muted-foreground leading-relaxed max-w-prose">
                  {feature.description}
                </p>

                <div className="absolute inset-0 border-[1.5px] border-transparent rounded-xl transition-all duration-500 group-hover:border-[#00DC82] group-hover:border-opacity-20" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}